import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import fieldConfigurationModel from './fieldConfigurationModel.vue';
import { configList, configStore } from './request';
export default {
  components: {
    fieldConfigurationModel
  },
  props: ['type', 'id'],
  data() {
    return {
      data: [],
      value: [],
      columns: [{
        slots: {
          title: '菜单'
        },
        scopedSlots: {
          customRender: 'menu'
        },
        dataIndex: 'name',
        key: 'name'
      }],
      fieldConfigurationShow: false,
      selectedIndex: '',
      selectedIndex2: ''
    };
  },
  created() {
    configList({
      customerId: this.id
    }, this.type).then(res => {
      res.map(item => {
        item.list.map(item2 => {
          item2.allSelected = false;
          let arr = item2.permissionsGroup.filter(item3 => item3.selected);
          if (arr.length == item2.permissionsGroup.length) {
            item2.allSelected = true;
          }
        });
      });
      this.data = res;
    });
  },
  methods: {
    onChange(e, arr, index) {
      e.selected = !e.selected;
      let num = e.associationId;
      if (num != 0) {
        // arr.list[index].permissionsGroup.map(item=>{
        //   if(item.id==num){
        //     item.selected=e.selected;
        //     if(item.associationId==0){
        //       arr.list[index].selected=e.selected;
        //     }
        //   }
        // })
      } else {
        arr.list[index].permissionsGroup.map(item => {
          if (item.associationId == 0) {
            arr.list[index].selected = e.selected;
          }
        });
      }
      let arr2 = arr.list[index].permissionsGroup.filter(item3 => item3.selected);
      if (arr2.length == arr.list[index].permissionsGroup.length) {
        arr.list[index].allSelected = true;
      } else {
        arr.list[index].allSelected = false;
      }
    },
    onSubmit() {
      let permissionsData = [];
      this.data.map(item => {
        item.list.map(item2 => {
          item2.permissionsGroup.map(item3 => {
            if (item3.selected) {
              let info = item3.id;
              if (item3.associationId == 0 && item2.allowField.length != 0) {
                let num = [];
                item2.allowField.map(item4 => {
                  if (item4.selected && item4.allowField != 0) {
                    num.push(item4.id);
                  }
                });
                if (num.length != 0) {
                  info = String(info) + ':' + num.join(',');
                }
              }
              permissionsData.push(info);
            }
          });
        });
      });
      configStore({
        customerId: this.id,
        permissionsData: permissionsData.join('-')
      }, this.type).then(res => {
        this.$message.success(this.$t('保存成功'));
        this.$router.go(-1);
      });
    },
    configureFun(arr, index, index2) {
      if (arr.length == 0) {
        this.$message.error(this.$t('没有可配置的字段'));
        return false;
      }
      this.fieldConfigurationShow = true;
      this.selectedIndex = index;
      this.selectedIndex2 = index2;
      this.$nextTick(() => {
        this.$refs.fieldConfiguration.init(arr);
      });
    },
    handleSure(arr) {
      this.data[this.selectedIndex].list[this.selectedIndex2].allowField = arr;
    },
    change2(index, data) {
      data.allSelected = !data.allSelected;
      data.selected = data.allSelected;
      data.permissionsGroup.map(item => {
        item.selected = data.allSelected;
      });
    }
  }
};